import { apiClient } from './api.client';
import type { components } from '../types/api.generated';

export type HealthResponse = components['schemas']['HealthResponse'];
export type VersionResponse = components['schemas']['VersionResponse'];

export const healthService = {
  /**
   * Health check
   */
  async check() {
    const response = await apiClient.GET('/health');
    if (response.error) throw new Error('Health check failed');
    return response.data;
  },

  /**
   * Get version info
   */
  async version() {
    const response = await apiClient.GET('/version');
    if (response.error) throw new Error('Failed to fetch version');
    return response.data;
  }
};
